import {$$} from "./Dom.ts";
import {openModalAjax} from "./eline/modaleAjax.ts";


document.addEventListener('DOMContentLoaded', () => {

    if (window.location.pathname.includes("profile/")) {
        console.log('Profile loaded');
        $$('.open_ajax_modal').forEach(element => {element.addEventListener('click', openModalAjax)})
    }
});